import { GET_VENDOR_DOWNLOAD_CENTRE } from "../../utils/constants";


const initialState = {
    vendorDownloadCentreList: []
};

function getVendorDownloadCentreReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_VENDOR_DOWNLOAD_CENTRE:
            return {
                ...state,
                vendorDownloadCentreList: payload?.data?.vendorPlanList || []
            };

        default:
            return state;
    }
};

export default getVendorDownloadCentreReducer
